import { Box, Grid, Typography } from "@mui/material";
import ImageBox from "components/ui/ImageBox";

const PriceList = () => {
  return (
    <>
      <Box display='block' width={{ xs: '50%', md: '30%' }} sx={{ margin: 'auto' }}>
        <ImageBox imageUrl={process.env.PUBLIC_URL + '/images/jubilee/price-mobile.jpg'} isBg={false} opc={0.0}>&nbsp;</ImageBox>
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={12} md={3}>
          <Box display='flex' width={{xs:'20%', md:'50%'}} height='100%' sx={{ margin: 'auto', alignItems: 'center', justifyContent: 'center'}}>
            <ImageBox imageUrl={process.env.PUBLIC_URL + '/images/jubilee/woman-mobile.jpg'} isBg={false} opc={0.0}>&nbsp;</ImageBox>
          </Box>
        </Grid>
        <Grid item xs={12} md={9}>
          <Grid container rowSpacing={{ xs: 3.5, md: 5 }} columnSpacing={{ xs: 1, md: 3 }} sx={{ fontSize: '2em', py: '1em' }} >
            <Grid item xs={3}>&nbsp;</Grid>
            <Grid item xs={3}><Typography variant='h3'>Senior Stylist</Typography></Grid>
            <Grid item xs={3}><Typography variant='h3'>Top Stylist</Typography></Grid>
            <Grid item xs={3}><Typography variant='h3'>Salon Director</Typography></Grid>
            <Grid item xs={3}><Typography variant='h4'>Hair Cut</Typography></Grid>
            <Grid item xs={3}><Typography variant='h4'>From £70</Typography></Grid>
            <Grid item xs={3}><Typography variant='h4'>From £80</Typography></Grid>
            <Grid item xs={3}><Typography variant='h4'>From £100</Typography></Grid>
            <Grid item xs={3}><Typography variant='h4'>Tint</Typography></Grid>
            <Grid item xs={3}><Typography variant='h4'>From £160</Typography></Grid>
            <Grid item xs={3}><Typography variant='h4'>From £170</Typography></Grid>
            <Grid item xs={3}><Typography variant='h4'>From £180</Typography></Grid>
            <Grid item xs={3}><Typography variant='h4'>Digital Perm</Typography></Grid>
            <Grid item xs={3}><Typography variant='h4'>From £220</Typography></Grid>
            <Grid item xs={3}><Typography variant='h4'>From £230</Typography></Grid>
            <Grid item xs={3}><Typography variant='h4'>From £250</Typography></Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} md={3}>
          <Box display='flex' width={{xs:'20%', md:'50%'}} height='100%' sx={{ margin: 'auto', alignItems: 'center', justifyContent: 'center' }}>
            <ImageBox imageUrl={process.env.PUBLIC_URL + '/images/jubilee/man-mobile.jpg'} isBg={false} opc={0.0}>&nbsp;</ImageBox>
          </Box>
        </Grid>
        <Grid item xs={12} md={9}>
          <Grid container rowSpacing={{ xs: 3.5, md: 5 }} columnSpacing={{ xs: 1, md: 3 }} sx={{ fontSize: '2em', py: '1em' }} >
            <Grid item xs={3}>&nbsp;</Grid>
            <Grid item xs={3}><Typography variant='h3'>Senior Stylist</Typography></Grid>
            <Grid item xs={3}><Typography variant='h3'>Top Stylist</Typography></Grid>
            <Grid item xs={3}><Typography variant='h3'>Salon Director</Typography></Grid>
            <Grid item xs={3}><Typography variant='h4'>Hair Cut</Typography></Grid>
            <Grid item xs={3}><Typography variant='h4'>From £55</Typography></Grid>
            <Grid item xs={3}><Typography variant='h4'>From £60</Typography></Grid>
            <Grid item xs={3}><Typography variant='h4'>From £80</Typography></Grid>
            <Grid item xs={3}><Typography variant='h4'>Tint</Typography></Grid>
            <Grid item xs={3}><Typography variant='h4'>From £130</Typography></Grid>
            <Grid item xs={3}><Typography variant='h4'>From £140</Typography></Grid>
            <Grid item xs={3}><Typography variant='h4'>From £150</Typography></Grid>
            <Grid item xs={3}><Typography variant='h4'>Perm</Typography></Grid>
            <Grid item xs={3}><Typography variant='h4'>From £135</Typography></Grid>
            <Grid item xs={3}><Typography variant='h4'>From £155</Typography></Grid>
            <Grid item xs={3}><Typography variant='h4'>From £165</Typography></Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default PriceList;
